import React, { useEffect } from "react";
import styled from "styled-components";
import algorithms from "../assets/images/algorithms.jpg";
import crypto from "../assets/images/Appled_Crypto.png";
import ml from "../assets/images/machine_learning.png";
import graph from "../assets/images/graph_theory.png";
import toc from "../assets/images/theory_of_computation.png";

const Recommendation = () => {
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND}/recommendation`, {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id: "10" }),
    })
      .then((res) => res.json())
      .then((res) => console.log(res));
  }, []);
  return (
    <RecommendationWrapper>
      <div className="accordian-wrapper">
        <div className="containerr">
          <h1>
            Here are some{" "}
            <a href="#" className="highlightt">
              <span>intellifAIed</span>
            </a>{" "}
            recommendations for you!
          </h1>
        </div>
        <div className="accordion">
          <ul>
            <li>
              <div>
                {" "}
                <a href="/">
                  <h2>Advanced Algorithms</h2>
                  <p>
                    We will start with networks flows which are used in more
                    typical applications such as optimal matchings, finding
                    disjoint paths and flight scheduling as well as more
                    surprising ones like image segmentation in computer vision.
                  </p>
                </a>{" "}
              </div>
            </li>
            <li>
              <div>
                {" "}
                <a href="#">
                  <h2>Applied Cryptography</h2>
                  <p>
                    Cryptography is an indispensable tool for protecting
                    information in computer systems. In this course you will
                    learn the inner workings of cryptographic systems and how to
                    correctly use them in real-world applications.
                  </p>
                </a>{" "}
              </div>
            </li>
            <li>
              <div>
                {" "}
                <a href="#">
                  <h2>Advanced graph theory</h2>
                  <p>
                    Advanced Graph Theory focuses on problem solving using the
                    most important notions of graph theory with an in-depth
                    study of concepts on the applications in the field of
                    computer science.
                  </p>
                </a>{" "}
              </div>
            </li>
            <li>
              <div>
                {" "}
                <a href="#">
                  <h2>Machine Learning</h2>
                  <p>
                    Machine learning is a branch of artificial intelligence (AI)
                    and computer science which focuses on the use of data and
                    algorithms to imitate the way that humans learn, gradually
                    improving its accuracy.
                  </p>
                </a>{" "}
              </div>
            </li>
            <li>
              <div>
                {" "}
                <a href="#">
                  <h2>Theory Of Computation</h2>
                  <p>
                    In theoretical computer science and mathematics, the theory
                    of computation is the branch that deals with what problems
                    can be solved on a model of computation, using an algorithm,
                    how efficiently they can be solved or to what degree.
                  </p>
                </a>{" "}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </RecommendationWrapper>
  );
};

const RecommendationWrapper = styled.div`
  /* The base code is from https://www.cssscript.com/demo/pure-css-vertical-image-accordion-slider/ I just adapted it in scss and put it on codepen*/
  @import url("https://fonts.googleapis.com/css?family=Bitter:700");

  .containerr {
    // background-color: #ededed;
    color: #343434;
    width: 100% // display: flex;
      // align-items: center;
      // justify-content: center;
      // min-height: 100vh;
      h1 {
      font-family: "Bitter", serif;
      line-height: 1.4;
      word-spacing: 3px;
      max-width: 45rem;
      text-shadow: 0px 1px 0px rgba(255, 255, 255, 1);
    }

    .highlightt {
      display: inline-block;
      color: #343434;
      transition: color 250ms, text-shadow 250ms;
      text-decoration: none;
      text-shadow: 0px 1px 0px rgba(255, 255, 255, 1);

      position: relative;
      z-index: 0;

      &::after {
        position: absolute;
        z-index: -1;
        bottom: -5px;
        left: 50%;
        transform: translateX(-50%);
        content: "";
        width: 100%;
        height: 3px;
        background-color: #343434;
        transition: all 250ms;
      }

      &:hover {
        color: white;
        text-shadow: 0px 1px 0px rgba(0, 0, 0, 1);

        &::after {
          height: 105%;
          width: 105%;
        }
      }
    }
  }
  .accordian-wrapper {
    height: 80vh;
    display: grid;
    place-items: center;
  }
  .accordion {
    scale: 1.5;
    width: 100%;
    max-width: 1080px;
    height: 250px;
    overflow: hidden;
    // margin: 50px auto;
    ul {
      width: 100%;
      display: table;
      table-layout: fixed;
      margin: 0;
      padding: 0;
      li {
        display: table-cell;
        vertical-align: bottom;
        position: relative;
        width: 33.33%;
        height: 250px;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
        transition: all 500ms ease;
        &:nth-child(1) {
          background-image: url(${algorithms});
        }
        &:nth-child(2) {
          background-image: url(${crypto});
        }
        &:nth-child(3) {
          background-image: url(${graph});
        }
        &:nth-child(4) {
          background-image: url(${ml});
        }
        &:nth-child(5) {
          background-image: url(${toc});
        }
        div {
          display: block;
          overflow: hidden;
          width: 100%;
          a {
            display: block;
            height: 250px;
            width: 100%;
            position: relative;
            z-index: 3;
            vertical-align: bottom;
            padding: 15px 20px;
            box-sizing: border-box;
            color: #fff;
            text-decoration: none;
            font-family: Open Sans, sans-serif;
            transition: all 200ms ease;
            * {
              opacity: 0;
              margin: 0;
              width: 100%;
              text-overflow: ellipsis;
              position: relative;
              z-index: 5;
              white-space: nowrap;
              overflow: hidden;
              transform: translateX(-20px);
              transition: all 400ms ease;
            }
            h2 {
              font-family: Montserrat, sans-serif;
              text-overflow: clip;
              font-size: 24px;
              text-transform: uppercase;
              margin-bottom: 2px;
              top: 160px;
            }
            p {
              top: 160px;
              font-size: 13.5px;
            }
          }
        }
      }
      /*ul*/
      &:hover {
        li {
          width: 10%;
          &:hover {
            width: 80%;
            a {
              background: rgba(0, 0, 0, 0.4);
              * {
                opacity: 1;
                transform: translateX(0);
              }
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 600px) {
    body {
      margin: 0;
    }
    .accordion {
      height: auto;
      ul li,
      ul li:hover,
      ul:hover li,
      ul:hover li:hover {
        position: relative;
        display: table;
        table-layout: fixed;
        width: 100%;
        -webkit-transition: none;
        transition: none;
      }
    }
  }
`;
export default Recommendation;
